import React from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {IVehicle} from '../../interface';

const cx = classnames.bind(style);

export interface IProps {
  dataList: IVehicle;
  className: string;
}

export const VehicleDropdown = (props: IProps) => {
  const { dataList, className } = props;
  return (
    <>
      <div data-testid="vehicle-selection" className={className ? cx('vehicle-selection', 'selected', className.toLowerCase()) : cx('vehicle-selection', 'selected')}>
        <div className={cx('dropdown')}>
          {dataList && (
            <>
              <strong>
                {`${dataList['make']}  ${dataList['model']}`}
              </strong>
              <div>
                <span className={`${cx('selected')}`}>
                  {dataList['type']}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default VehicleDropdown;
